import { TextBadge } from '@carvana/ds-badge';
import { background, border, text } from '@carvana/ds-styles';
import { Check } from 'lucide-react';

export default function IncludedBadge() {
  return (
    <TextBadge
      customBgColor={background.default}
      customBorderColor={border.subtle}
      customFontColor={text.strong}
      iconLeft={() => <Check color={text.success} size={16} />}
      priority="custom"
    >
      Standard
    </TextBadge>
  );
}
